<template>
    <div class="space-y-2">
        <draggable :list="rams.paragraphs" draggable=".draggable" handle=".handle" @change="fieldsReordered"
                   class="space-y-2">
            <div v-for="(field, index) in rams.paragraphs" :key="index" class="draggable p-2 rounded-lg"
                 :class="(rams.response && rams.response.perItemComments && rams.response.perItemComments.paragraphs[index])?'bg-red-50':''">
                <div class="flex items-start mb-1">
                    <div class="w-6 flex-shrink-0 py-1.5" v-if="!rams.readonly">
                        <i class="fa fa-bars text-sm text-gray-300 hover:text-gray-500 cursor-move handle"></i>
                    </div>
                    <div class="w-16 h-16 flex-shrink-0 p-0 mb-1 mr-1.5">
                        <ui-icon-picker @selected="(iconClass) => iconSelected(field, iconClass)" :key="iconUpdates"
                                        v-if="!rams.readonly">
                            <div
                                class="h-full w-full border border-gray-300 rounded-xl flex items-center align-middle cursor-pointer">
                                <span class="text-gray-500 w-full text-center text-3xl" v-if="field.iconClass"
                                      :class="field.iconClass"></span>
                                <span class="text-gray-300 w-full text-center" v-else>No Icon</span>
                            </div>
                        </ui-icon-picker>
                        <div class="h-full w-full border border-gray-300 rounded-xl flex items-center align-middle"
                             v-else>
                                <span class="text-gray-500 w-full text-center text-3xl" v-if="field.iconClass"
                                      :class="field.iconClass"></span>
                            <span class="text-gray-300 w-full text-center" v-else>No Icon</span>
                        </div>
                    </div>
                    <div class="flex-1">
                        <input
                            placeholder="Untitled field"
                            class="bg-transparent flex-1 bottom-0 mb-1.5 text-sm m-0 px-2 py-1 pb-1.5 font-medium text-gray-700 border-transparent rounded shadow-none relative focus:z-10"
                            type="text"
                            ref="titles"
                            :disabled="rams.readonly"
                            v-model="field.title"
                            @input="saveIt()"
                            @change="rams.update()"
                            @keydown.enter.prevent="$emit('change', $event.target.value);$event.target.blur()"
                        >
                        <ui-textarea
                            ref="paraTextAreas"
                            autoresize
                            rows="1"
                            field="resize-none"
                            name="content"
                            :disabled="rams.readonly"
                            v-model="field.content"
                            @input="saveIt()"
                            @change="rams.update()"
                        ></ui-textarea>
                    </div>
                    <div class="w-6 flex-shrink-0 ml-2 self-start py-1.5">
                        <ui-dropdown menu-class="p-3 w-56" v-if="!rams.readonly">
                            <template #default="{ toggle }">
                                <button @click="toggle"
                                        class="w-5 h-5 flex items-center justify-center text-gray-300 hover:text-gray-500 focus:outline-none focus:ring-2 focus:ring-blue-600 focus:z-10 relative rounded">
                                    <i class="fa fa-ellipsis-h fa-fw"></i>
                                </button>
                            </template>
                            <template #menu="{ close }">
                                <ui-dropdown-item icon="fas fa-trash" danger @click="deleteField(index); close()">
                                    Delete
                                </ui-dropdown-item>
                            </template>
                        </ui-dropdown>
                    </div>
                </div>
                <div class="p-2 text-red-500"
                     v-if="rams.response && rams.response.perItemComments && rams.response.perItemComments.paragraphs[index]">
                    <div class="flex">
                        <label>Rejection comments:</label>
                    </div>
                    <div
                        class="bg-white whitespace-pre-wrap m-0 px-3 py-2 relative rounded-md shadow-sm block w-full border sm:text-sm focus:outline-none focus:ring-light-blue-500 focus:border-light-blue-500 border-gray-300 placeholder-gray-400"
                        v-text="rams.response.perItemComments.paragraphs[index]"></div>
                </div>
            </div>
        </draggable>

        <!-- New Item. -->
        <div class="relative" v-if="!rams.readonly">
            <input
                placeholder="Add New Paragraph..."
                class="text-sm m-0 pl-8 pr-2 py-1 font-bold text-gray-900 border-transparent rounded shadow-none relative"
                type="text"
                v-model="newFieldTitle"
                @input="addField"
            >
            <div class="absolute left-0 inset-y-0 w-8 flex items-center justify-center">
                <i class="fa fa-plus text-sm text-gray-400"></i>
            </div>
        </div>
    </div>
</template>

<script>
import draggable from 'vuedraggable'
import {RAMS} from "../../../models";
import UiDropdownItem from "../../ui/UiDropdownItem.vue";
import UiDropdown from "../../ui/UiDropdown.vue";
import UiTextarea from "../../ui/UiTextarea.vue";
import UiIconPicker from "../../ui/UiIconPicker.vue";
import {debounce} from "lodash";

export default {
    components: {
        UiIconPicker,
        UiTextarea,
        UiDropdown,
        UiDropdownItem,
        draggable,
    },
    props: {
        rams: RAMS
    },
    data() {
        return {
            newFieldTitle: '',
            iconUpdates: 0,
            saveIt: debounce(this.save, 400, {leading: true, maxWait: 3000}),
        }
    },
    methods: {
        save() {
            this.rams.save();
        },
        addField() {
            this.rams.paragraphs.push({
                title: this.newFieldTitle,
                content: '',
            })
            this.rams.update()
            this.$nextTick(() => {
                const input = this.$refs.titles[this.$refs.titles.length - 1]
                input.focus()
                this.newFieldTitle = ''
            })
        },
        iconSelected(field, iconClass) {
            field.iconClass = iconClass
            this.iconUpdates++;
            this.rams.update()
        },
        deleteField(index) {
            this.rams.paragraphs.splice(index, 1)
            this.rams.update()
        },
        fieldsReordered(e) {
            this.$refs['paraTextAreas'].forEach((i) => {
                i.$refs['autoresizable-textarea'].$el.style.height = 'auto'
                i.resize();
            })
            this.rams.update()
        },
    },
}
</script>
